import { UserSidebar } from '@/components/layout/UserSidebar'
import EpisodeCard from '@/components/ui/EpisodeCard'
import { Link } from '@inertiajs/react'
import type { EpisodeCard as EpisodeCardType } from '@/types'

export default function Index({ episodes }: { episodes: EpisodeCardType[] }) {
  return (
    <div className="min-h-screen bg-gray-50 flex">
      <UserSidebar active="/favorites" />
      <main className="flex-1 p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">
          Saved lessons <span className="text-xl text-gray-400 font-normal">({episodes.length})</span>
        </h1>

        {episodes.length > 0 ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {episodes.map((ep, i) => (
              <EpisodeCard key={ep.id} episode={ep} index={i} />
            ))}
          </div>
        ) : (
          <div className="text-center py-20 text-gray-400">
            <p className="mb-3">No saved lessons yet.</p>
            <p className="text-sm mb-4">Bookmark an episode to save it here.</p>
            <Link href="/episodes" className="text-brand hover:underline">Browse episodes →</Link>
          </div>
        )}
      </main>
    </div>
  )
}
